/**
 * Плагин работы с числами
 */

 const numbers = {
    /**
     * Удаляет незначащие нули
     *
     * @param {number} val Исходное число с плавающей точкой
     *
     * @returns {string}
     */
    dropZeros (val) {
        let result = parseFloat(val);

        result = result.toFixed(3).substring(result.toFixed(3).length, result.toFixed(3).length - 1) == "0"
            ? parseFloat(result.toFixed(2))
            : parseFloat(result.toFixed(3));

        if (result == parseInt(val)) {
            result += ".0";
        }

        return isNaN(result) ? "" : result;
    },

    /**
     * Форматирование чисел
     *
     * @param {number} val Исходное число
     *
     * @returns {string}
     */
    numberWithSpaces(val) {
        let parts = val.toString().indexOf(",")
            ? val.toString().split(",")
            : val.toString().split(".");

        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");

        return val.toString().indexOf(",")
            ? parts.join(",")
            : parts.join(".");
    },
}

export default numbers;
